<template>
  <!-- 外层容器 -->
  <div class="w-full h-auto py-[2.5vw] bg-white">
    <!-- 容器区域 -->
    <div
      class="relative w-[61.46vw] h-auto mx-auto gap-[1.3vw] flex flex-row items-start"
    >
      <!-- 左侧容器 -->
      <div
        class="news-item w-auto h-auto flex-1 p-[1.04vw] border border-[#EEEEEE]"
      >
        <!-- 内容容器 -->
        <div
          class="flex flex-col gap-[0.94vw] font-harmony font-normal text-start"
        >
          <!-- 标题 -->
          <div class="text-[1.25vw] text-[#1A2233]">
            {{ newsDetail.title }}
          </div>

          <!-- 日期 -->
          <div
            class="flex justify-start items-center p-[0.52vw] text-[0.73vw] text-[#666666] bg-[#F0F1F1] border border-[#DBDBDB] rounded-[0.2vw]"
          >
            <i
              class="el-icon-date flex justify-start items-center mx-[0.2vw] text-[#05358C] font-medium"
            ></i>
            {{ newsDetail.date | formatZhDate }}
          </div>

          <!-- 富文本内容支持 HTML -->
          <div
            class=" text-[#333333] text-[0.83vw] font-harmony rich-content"
            v-html="newsDetail.content"
          ></div>
        </div>

          <!--<img    v-show="newsDetail.base64Value.length > 0"
                  class="w-full h-full object-center object-cover rounded-t"
                  :src="newsDetail.base64Value"
          />-->
        <!-- 虚线分隔 -->
        <div
          class="w-full border-b border-[#b3b3b3] h-[0.05vw] mt-[2.19vw]"
        ></div>
        <!-- 切页组件 -->
        <div
          class="w-full flex justify-center items-center mt-[1.04vw] mb-[2.19vw]"
        >
<!--          <el-button-->
<!--            type="text"-->
<!--            class="custom-textbutton"-->
<!--            @click="goToPreviousArticle"-->
<!--          >-->
<!--            <i class="el-icon-arrow-left el-icon&#45;&#45;left"></i>-->
<!--            上一篇-->
<!--          </el-button>-->
          <!-- 按钮容器 -->
          <el-button
            size="small"
            class="custom-button"
            @click="$router.push({ path: '/News' })"
          >
            返回列表
          </el-button>
<!--          <el-button-->
<!--            type="text"-->
<!--            class="custom-textbutton"-->
<!--            @click="goToNextArticle"-->
<!--          >-->
<!--            下一篇-->
<!--            <i class="el-icon-arrow-right el-icon&#45;&#45;right"></i>-->
<!--          </el-button>-->
        </div>
      </div>
      <!-- 右侧容器 -->
      <NewsSidebar :rightShowNews="rightShowNews" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import NewsSidebar from "@/components/NewsSidebar/NewsSidebar.vue";
import { marked } from "marked";
import {listNewsAll,getById} from "@/api/newsInfo";
export default {
    name: "sub_news-module2",
    components: {
      NewsSidebar,
    },
    metaInfo() {
        return {
            title: this.newsDetail.tdkTitle || '蓝悦教育 - 专注青少年无人机培训 | 科技特长生培养基地 | 教育部白名单赛事指定机构',
            meta: [
                {
                    name: 'description',
                    content: this.newsDetail.tdkDescribe || '蓝悦教育专注6-18岁青少年无人机科技创新教育，提供全学段无人机课程、教育部白名单赛事培训及校区加盟服务。民航局认证资质+西工大产学研合作，助力科技特长生升学。立即咨询课程/加盟政策：029-8928 4201'
                },
                {
                    name: 'keywords',
                    content: this.newsDetail.tdkKeyword || '青少年无人机培训， 无人机课程加盟， 教育部白名单赛事， 全国无人机大赛培训，蓝悦教育'
                }
            ]
        }},
        data() {
            return {
              // 当前新闻详情
              newsDetail: {
                  documentId: "",
                  title: "",
                  date: "",
                  content: "",
                  base64Value:"",
                  category:"",
                  tdkTitle:'',
                  tdkKeyword:'',
                  tdkDescribe:''
      },
      // 新闻列表（按发布时间降序排序），每个元素包含 documentId 字段
        rightShowNews: [],
    };
  },
  created() {
    // 首先获取所有新闻列表数据，再根据路由参数获取详情数据
    // this.fetchNewsList().then(() => {
    //   this.fetchNewsDetail();
    // });
      this.fetchNewsDetail().then(() => {
          this.fetchNewsList();
      })
  },
  methods: {
    // 获取新闻列表数据，返回值中的 documentId 用于路由跳转
    async fetchNewsList() {
      try {
        // 假定接口支持排序参数，按发布时间降序排列
        const response = await listNewsAll(1,4,this.newsDetail.category);
        // 假设返回数据在 response.data.data 数组中
        this.rightShowNews = response.data.records;
      } catch (error) {
        console.error("获取新闻列表失败", error);
      }
    },
    // 根据路由中的 documentId 字段获取当前新闻详情
    async fetchNewsDetail() {
      const documentId = this.$route.params.documentId;
      try {
        // 通过过滤条件获取 documentId 对应的数据（注意这里的过滤条件语法依据 Strapi API 格式）
        const response = await getById(documentId);
        if(response.success === false){
            throw new Error("未找到此新闻");
        }
          const data = response.data;
          this.newsDetail = {
            documentId: data.id, // 使用 documentId 字段
            title: data.newsTitle,
            date: data.publishedAt,
            content: data.newsContentHtml,
              category:data.newsCategory,
               tdkTitle : data.tdkTitle,
               tdkKeyword : data.tdkKeyword,
               tdkDescribe : data.tdkDescribe
          }
      } catch (error) {
        console.error("获取新闻详情失败", error);
      }
    },
    // 点击“上一篇”时，根据当前新闻在列表中的位置跳转
    goToPreviousArticle() {
      const currentIndex = this.rightShowNews.findIndex(
        (item) => String(item.documentId) === String(this.newsDetail.documentId)
      );
      if (currentIndex > 0) {
        const previousArticle = this.rightShowNews[currentIndex - 1];
        // 使用绝对路径跳转，确保地址后缀为 documentId
        this.$router.push({ path: `/News/info/${previousArticle.documentId}` });
      } else {
        // 弹出提示消息
        this.$message({
          message: "已经是第一篇文章",
        });
      }
    },
    // 点击“下一篇”时，根据当前新闻在列表中的位置跳转
    goToNextArticle() {
      const currentIndex = this.rightShowNews.findIndex(
        (item) => String(item.documentId) === String(this.newsDetail.documentId)
      );
      if (currentIndex < this.rightShowNews.length - 1) {
        const nextArticle = this.rightShowNews[currentIndex + 1];
        this.$router.push({ path: `/News/info/${nextArticle.documentId}` });
      } else {
        // 弹出提示消息
        this.$message({
          message: "已经是最后一篇文章",
        });
      }
    },
  },

  watch: {
    // 监听路由参数变化，重新获取详情数据
    "$route.params.documentId"(newId, oldId) {
      if (newId !== oldId) {
        this.fetchNewsDetail();
      }
      // 跳转后回顶部
      // window.scrollTo({ top: 0 });
    },
  }
};
</script>






<style scoped>
/* 自定义按钮样式 */
.custom-button {
  background: #05358c !important;
  border-radius: 0.2vw !important;
  transition: all 0.3s !important;
}

.custom-button :deep(span) {
  color: #ffffff !important;
  font-size: 0.73vw !important;
  font-weight: normal !important;
  font-family: "HarmonyOS Sans SC";
}

.custom-button:hover {
  background: #1c9af3 !important;
}

.custom-textbutton {
  transition: all 0.3s !important;
}

.custom-textbutton :deep(span) {
  color: #999999 !important;
  font-size: 0.73vw !important;
  font-weight: normal !important;
  font-family: "HarmonyOS Sans SC";
}

.custom-textbutton:hover :deep(span) {
  color: #d9d9d9 !important;
}

/* 富文本内容样式 */
::v-deep .rich-content img {
  display: block;
  margin: 0.52vw auto;
  max-width: 100%;
  height: auto;
}

::v-deep .rich-content a{
    @apply text-blue-500;
}
</style>
